import http from "@/http/aisea/axios";
const resource = "/secure_dataflow/enterprise/vessels";

export default {
  getBatchData(vesselId, params) {
    return http.get(`${resource}/${vesselId}/batch_data`, {
      params: params
    });
  }
};
